/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-26 19:43:51
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-01-26 19:44:06
 * @FilePath: /knit-web/src/locale/zh-CN/account.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  account: {
    title: '账号',
    language: '语言',
    languageZhCN: '中文',
    languageEnUS: 'English',
    name: '姓名',
    email: '邮箱',
    edit: '编辑',
    cancel: '取消',
    save: '保存',
    namePlaceholder: '请输入姓名',
    nameRequired: '姓名不能为空',
    updateSuccess: '更新成功',
    updateFailed: '更新失败',
  },
};
